// «Inaktiv» owner/animal helpers.
//
// visitor.isInactive is a toggle stored as 1/0 (same as skipBulkSms), animal.isInactive
// is a Boolean. The backend cascades the owner's flag onto the owner's animals, so the
// animal pickers only look at the animal.
//
// Inactive owners are NOT removed from the visitor search: the sale search is the only
// clinic page where an owner can be found again, so they stay listed, greyed and last.

const INACTIVE_ON_VALUES = [1, '1', true, 'true'];

export function isInactive(obj) {
    return !!obj && INACTIVE_ON_VALUES.includes(obj.isInactive);
}

// Pure: returns a new array with inactive visitors after the active ones, order kept
// within each group (stable). Tolerates a non-array (failed load).
export function sortInactiveLast(list) {
    if (!Array.isArray(list)) {
        return list;
    }
    const active = list.filter(e => !isInactive(e));
    const inactive = list.filter(e => isInactive(e));
    return [...active, ...inactive];
}
